import {rqCreateRequest} from '../../../ReactQuery/apis/rqHttpUtils';

const BILL_API = {
  GET_ALL: {
    url: 'api/bill/lookup/all',
    method: 'GET',
    auth: true,
  },

  GET_BY_ID: {
    url: 'api/bill/lookup/${billId}',
    method: 'GET',
    auth: true,
  },

  GET_BY_PATIENT: {
    url: 'api/bill/lookup/patient/${patientId}',
    method: 'GET',
    auth: true,
  },

  CREATE: {
    url: 'api/bill/create',
    method: 'POST',
    auth: true,
  },

  UPDATE: {
    url: 'api/bill/update/${billId}',
    method: 'PUT',
    auth: true,
  },

  DELETE: {
    url: 'api/bill/delete/${billId}',
    method: 'DELETE',
    auth: true,
  },
};

// ==================================================
// GET ALL BILLS
// ==================================================

export const getBills = token => {
  return rqCreateRequest(
    BILL_API.GET_ALL,
    null,
    token,
    null,
    null,
  );
};

// ==================================================
// GET BILL BY ID
// ==================================================

export const getBillById = (
  billId,
  token,
) => {
  return rqCreateRequest(
    BILL_API.GET_BY_ID,
    null,
    token,
    {billId},
    null,
  );
};

// ==================================================
// GET BILLS BY PATIENT
// ==================================================

export const getBillsByPatient = (
  patientId,
  token,
) => {
  return rqCreateRequest(
    BILL_API.GET_BY_PATIENT,
    null,
    token,
    {patientId},
    null,
  );
};

// ==================================================
// CREATE BILL
// ==================================================

export const createBill = (
  billData,
  token,
) => {
  return rqCreateRequest(
    BILL_API.CREATE,
    billData,
    token,
    null,
    null,
  );
};

// ==================================================
// UPDATE BILL
// ==================================================

export const updateBill = (
  billId,
  billData,
  token,
) => {
  return rqCreateRequest(
    BILL_API.UPDATE,
    billData,
    token,
    {billId},
    null,
  );
};

// ==================================================
// DELETE BILL
// ==================================================

export const deleteBill = (
  billId,
  token,
) => {
  return rqCreateRequest(
    BILL_API.DELETE,
    null,
    token,
    {billId},
    null,
  );
};
